module.exports = __webpack_public_path__ + "img/28486039000180.13cf16bb.png";